import WelcomeScreenLightbox from './components/WelcomeScreenLightbox'
import {bindActionCreators} from "redux"
import {connect} from '../../redux/utils'
import {getDemoDataStage, getHeight, getLoadExternalWelcomeScreen, getLoading, getShowExternalContent, getSize, getStage, getUrl, getWidth} from './selectors'
import {openLightbox, closeLightbox, sendMessage, setShowExternalContent} from './actions'
import $ from '../../alias/jquery'
import {DemoDataStageType, WelcomeScreenFrameId} from './constants'
import StateComponent from '../../StateComponent'
import emitUserEvent from '../../userEvents/emitUserEvent'
import {UserEventsMap} from '../../userEvents/UserEventsMap'

class WelcomeScreenContainer extends StateComponent {
    constructor({
            $containerEl = $('body'),
            openLightbox,
            closeLightbox,
            sendMessage,
            setShowExternalContent,
        }
    ) {
        super($containerEl)
        this.state = {
            loading: false,
            showExternalContent: false,
            loadExternalWelcomeScreen: false,
            demoDataStage: DemoDataStageType.IDLE,
            url: '',
            width: 0,
            height: 0,
            isLightboxShown: false
        }

        this.params = {
            openLightbox,
            closeLightbox,
            sendMessage,
            setShowExternalContent,
        }

        //This reaction is emitted event if previous `showExternalContent` state was the same
        //Therefore we need flag `isLightboxShown` to prevent double call of `lightbox.show()`
        this.onStatePropertyChanged('showExternalContent', showExternalContent => {
            if (showExternalContent && !this.state.isLightboxShown) {
                this.setState({ isLightboxShown: true })
                this.lightbox.show()
            } else if (!showExternalContent) {
                this.setState({ isLightboxShown: false })
                this.lightbox.hide()
                //remove all loadings and event listeners for iframe
                const iframeEl = $('#' + WelcomeScreenFrameId)[0]
                if (iframeEl)
                    iframeEl.remove()
            }
        })

        this.onStatePropertyChanged('url', url => {
            this.lightbox.changeUrl(url)
        })

        this.onAnyStatePropertyChanged(['width', 'height'], () => {
            this.lightbox.changeSize({
                width: this.state.width,
                height: this.state.height,
            })
        })
    }

    init() {
        this.lightbox = new WelcomeScreenLightbox({
            onCloseCallback: this.params.closeLightbox,
            iframeLoadCallback: this.params.sendMessage,
            frameName: WelcomeScreenFrameId,
            loadExternalWelcomeScreen: this.state.loadExternalWelcomeScreen,
        })
        this.lightbox.init()

        this.params.openLightbox()
        this.params.setShowExternalContent(true)
        emitUserEvent(UserEventsMap.POPUP_OPENED)
    }
}

export default connect(
    (state) => ({
        loading: getLoading(state),
        showExternalContent: getShowExternalContent(state),
        demoDataStage: getDemoDataStage(state),
        url: getUrl(state),
        width: getWidth(state),
        height: getHeight(state),
        loadExternalWelcomeScreen: getLoadExternalWelcomeScreen(state)
    }),
    dispatch => bindActionCreators({
        openLightbox,
        closeLightbox,
        setShowExternalContent,
        sendMessage,
    }, dispatch)
)(WelcomeScreenContainer)


// WEBPACK FOOTER //
// ./web/js/support/welcomeScreen/WelcomeScreenContainer.js